var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-panel load-bg"},[_c('div',{staticClass:"spinner"},[(_vm.loading)?_c('pulse-loader',{attrs:{"color":_vm.color,"size":_vm.size}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }